import React from 'react';
import { Box, Button, Card, CardContent, Chip, LinearProgress, Stack, Typography } from '@mui/material';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import { Link as RouterLink } from 'react-router-dom';

import { formatRunDuration, runContextLabel, runStatusColor } from '../utils/assetRuns';


function formatDate(value) {
  if (!value) return 'N/A';
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString();
}


export default function AssetRunCard({ run, showContext = true, compact = false }) {
  const progress = run?.progress ?? run?.progress_percent;
  const hasProgress = progress !== null && progress !== undefined && Number.isFinite(Number(progress));
  const shortId = String(run?.run_id || '').slice(0, 8);

  return (
    <Card variant="outlined" sx={{ borderRadius: 2 }}>
      <CardContent sx={{ p: compact ? 1.5 : 2, '&:last-child': { pb: compact ? 1.5 : 2 } }}>
        <Stack spacing={1.25}>
          <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={1}>
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="subtitle2" sx={{ fontWeight: 850, wordBreak: 'break-word' }}>
                {run?.asset?.asset_name || 'Asset Run'}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Run {shortId || run?.run_id}
              </Typography>
            </Box>
            <Chip size="small" color={runStatusColor(run?.status)} label={String(run?.status || 'unknown').replace(/_/g, ' ').toUpperCase()} />
          </Stack>
          {hasProgress ? (
            <Box>
              <Stack direction="row" justifyContent="space-between">
                <Typography variant="caption" color="text.secondary">Progress</Typography>
                <Typography variant="caption" sx={{ fontWeight: 750 }}>{Math.round(Number(progress))}%</Typography>
              </Stack>
              <LinearProgress variant="determinate" value={Math.max(0, Math.min(100, Number(progress)))} sx={{ mt: 0.5, borderRadius: 1 }} />
            </Box>
          ) : null}
          <Typography variant="caption" color="text.secondary">
            Started {formatDate(run?.started_at)} · Duration {formatRunDuration(run?.duration_seconds)}
          </Typography>
          {run?.asset_status?.activity ? (
            <Typography variant="caption" color="text.secondary">
              Current activity: {run.asset_status.activity}
            </Typography>
          ) : null}
          {showContext ? (
            <Typography variant="caption" color="text.secondary">
              Shared with: {runContextLabel(run)}
            </Typography>
          ) : null}
          <Stack direction="row" justifyContent="flex-end">
            <Button
              component={RouterLink}
              to={`/runs/${encodeURIComponent(run?.run_id || '')}`}
              size="small"
              endIcon={<OpenInNewRoundedIcon />}
            >
              View Run
            </Button>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
